/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chose_Cov_Sensor_ModeInputs */



/**
* | output |
* | --- |
* | "Choose air quality sensor mode" |
*
* @param {Chose_Cov_Sensor_ModeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const chose_cov_sensor_mode = /** @type {((inputs?: Chose_Cov_Sensor_ModeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chose_Cov_Sensor_ModeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Choose air quality sensor mode")
	return /** @type {LocalizedString} */ ("Choisir le mode du capteur de qualité de l'air")
});